export const Tick = ({ color = "currentColor" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1250_313314)">
        <path
          d="M2 8.95455L5.48 12.25L13.6 5"
          stroke={color}
          strokeWidth="2.35625"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1250_313314">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
